var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAbsoluteValue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "absolute value",
  d: "M10.21 12.35H8.44v-.09a15.76 15.76 0 0 0-.59-1.49c-.21-.47-.43-.93-.64-1.37l-2.62 2.95h-2l3.85-4.3-2-4h1.81L7.6 6.83c.38-.47.74-.93 1.07-1.36s.68-.94.95-1.37v-.06h1.87l-.14.19c-.44.65-.93 1.32-1.47 2s-1.01 1.28-1.54 1.9c.32.63.64 1.29 1 2a20.37 20.37 0 0 1 .85 2.09ZM14 .5v13h-1.9V.5ZM1.9.5v13H0V.5Z"
})));
export default SvgAbsoluteValue;